import { POSTAL_CODE_REGEX } from '@/constants/regex';

export type NewAddressUi = {
  street: string;
  streetError?: string;
  addressTag: string;
  addressTagError?: string;
  externalNumber: string;
  externalNumberError?: string;
  internalNumber: string;
  postalCode: string;
  postalCodeError?: string;
  colonia: string;
  coloniaError?: string;
};

export const initialState: NewAddressUi = {
  street: '',
  externalNumber: '',
  internalNumber: '',
  postalCode: '',
  colonia: '',
  addressTag: '',
};

export const isInvalidAddress = (address: NewAddressUi): boolean => {
  if (!address.addressTag.trim()) return true;
  if (!address.colonia.trim()) return true;
  if (!address.street.trim()) return true;
  if (!address.externalNumber.trim()) return true;
  if (!POSTAL_CODE_REGEX.test(address.postalCode)) return true;
  return false;
};
